import './scss/index.scss';
import { dcFactory } from 'dc';
import { MembershipFormComponent } from './js/membership-form.component';

dcFactory.register(MembershipFormComponent);
